/*
 * File: \src\service\data-rangers\index.js
 * Created Date: 2020-11-05 09:13:28
 * Author: gaozw
 * -----
 * Last Modified: 2020-12-18 11:28:41
 * Modified By: gaozw
 */
 import DataRangers from 'mds-libs/libs/common/service/data-rangers/src/index.js'
 import _config from './config'
 
const dataRanger = new DataRangers(_config)
dataRanger.install = Vue => Vue.prototype.$_dataRanger = dataRanger

export default dataRanger
